/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  InputLabel,
  FormHelperText,
  Grid,
  Box,
  OutlinedInput,
  OutlinedInputProps,
} from '@mui/material'
import * as React from 'react'
import { IMaskInput } from 'react-imask'

interface IMaskedInputProps {
  onChange: (e: { target: { name: string; value: string } }) => void
  name?: string
}

const MaskedInput = React.forwardRef<HTMLInputElement, IMaskedInputProps>(
  ({ onChange, ...rest }, ref) => {
    const handleChange = (val: string) => {
      onChange({ target: { name: rest.name || '', value: val } })
    }
    return (
      <IMaskInput
        {...rest}
        mask={Number}
        onAccept={handleChange}
        unmask="typed"
        overwrite
        inputRef={ref}
        thousandsSeparator="."
        radix=","
        min={0}
      />
    )
  }
)

interface NumberFieldProps extends OutlinedInputProps {
  helperText?: string
}

const NumberField = ({ sx, helperText, label, ...rest }: NumberFieldProps) => {
  return (
    <Box component={Grid} container>
      <InputLabel
        sx={theme => ({
          color: theme.palette.common.black,
          fontWeight: 400,
          fontSize: 12,
        })}
        id="input-label"
      >
        {label}
      </InputLabel>
      <OutlinedInput
        {...rest}
        type="text"
        sx={{
          height: 40,
          ...{ ...sx },
        }}
        inputComponent={MaskedInput as any}
      />
      {helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </Box>
  )
}

export default NumberField
